import React from "react"
import parse, { domToReact } from "html-react-parser"
import { OutboundLink } from "./link"
import { Box } from "theme-ui"

const HtmlParser = ({ html, theme }) => {
  const options = {
    replace: ({ attribs, name, children }) => {
      switch (name) {
        case "a":
          return (
            <OutboundLink
              sx={{ color: theme === "dark" ? "light" : "primary" }}
              href={attribs.href}
            >
              {domToReact(children)}
            </OutboundLink>
          )
      }
    },
  }
  return (
    <Box sx={{ color: theme === "dark" ? "light" : "dark" }}>
      {parse(html, options)}
    </Box>
  )
}

export default HtmlParser
